export enum OrderButtonEnum {
  READY = "ready",
  ORDERED = "ordered",
  LOADING = "loading",
}
